module.exports = __webpack_public_path__ + "static/img/classmates.6996bb89.png";